import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import BreachlinkTermsofServiceV20231002 from "./BreachlinkTermsofServiceV20231002";
//test

const stats = [
  {
    id: 1,
    name: "",
    value: "Vender Terms",
    href: "/terms/vendor-terms.html",
  },
  {
    id: 2,
    name: "",
    value: "Consumer Terms",
    href: "/terms/consumer-terms.html",
  },
];

export default function Terms() {
  return (
    <div className="flex h-screen items-center justify-center bg-white px-6 py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl w-full">
        <div className="mx-auto max-w-2xl lg:max-w-none">
          <div className="text-center">
            <h2 className="text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl">
              Breachlink Terms of Service
            </h2>
            <p className="mt-4 text-lg/8 text-gray-600">
              Select the appropriate terms of service for your role.
            </p>
          </div>
          <dl className="mt-16 grid grid-cols-1 gap-4 text-center sm:grid-cols-2 lg:grid-cols-2 px-4">
            {stats.map((stat) => (
              <a
                key={stat.id}
                href={stat.href}
                className="bg-white shadow-lg rounded-xl border border-gray-200 flex flex-col p-8 hover:bg-gray-50 transition"
              >
                <dt className="text-sm/6 font-semibold text-gray-600">
                  {stat.name}
                </dt>
                <dd className="order-first text-3xl font-semibold tracking-tight text-gray-900">
                  {stat.value}
                </dd>
              </a>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}

// export default function Terms() {
//   const html = ``;
//   //display terms of service here
//   return (
//     // <div
//     //   className="h-screen m-6 bg-white rounded-md shadow"
//     //   // dangerouslySetInnerHTML={{ __html: html }}
//     // >
//     //   {/* Two centered buttons */}
//     //   <div className="h-full flex justify-center space-x-4">
//     //     <button className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
//     //       Vendor
//     //     </button>
//     //     <button className="py-auto bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400">
//     //       Consumer
//     //     </button>
//     //   </div>
//     // </div>
//   );
// }
